import React from 'react';
import {
  MessageSquare,
  Target,
  Calculator,
  Users,
  Award,
  TrendingUp,
} from 'lucide-react';

const iconMap = {
  MessageSquare,
  Target,
  Calculator,
  Users,
  Award,
  TrendingUp,
};

const FeaturesSection = ({ features }) => {
  return (
    <section style={{ background: 'var(--bg-card)', padding: '120px 0' }}>
      <div className="container">
        <div style={{ marginBottom: '80px', textAlign: 'center' }}>
          <h2 className="heading-2" style={{ color: 'var(--text-primary)', marginBottom: '24px' }}>
            WHAT YOU GET
          </h2>
          <p className="body-medium" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            Data-driven insights that actually help you make better decisions for your child's education.
          </p>
        </div>

        <div className="pixel-pushers-grid">
          {features.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                style={{
                  background: 'var(--bg-page)',
                  padding: '40px',
                  width: 'calc(50% - 10px)',
                  minWidth: '300px',
                  border: '2px solid var(--border-medium)',
                  borderRadius: '8px',
                  transition: 'all 0.3s ease',
                }}
                className="feature-card"
              >
                <div
                  style={{
                    width: '56px',
                    height: '56px',
                    background: 'var(--brand-primary)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '24px',
                  }}
                >
                  {IconComponent && <IconComponent size={28} color="var(--text-inverse)" />}
                </div>
                <h3
                  className="heading-5"
                  style={{
                    color: 'var(--text-primary)',
                    marginBottom: '12px',
                  }}
                >
                  {feature.title}
                </h3>
                <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
